/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import styled from 'styled-components';
import ds from 'designsystem';
import { observer, inject } from 'mobx-react';
import Bind from 'lodash-decorators/bind';
import root from 'window-or-global';
import VisibilitySensor from 'react-visibility-sensor';
import { Column, Row } from 'hedron';
import Fade from 'react-reveal/Fade';
import { FADE_VALUES, scrollTo } from 'animations/Animations';
import { media } from 'common/responsive';
import ANCHOR from 'common/consts/anchor';
import { dashesToUnderscores, underscoresToDashes } from 'common/methods/string';

import Container from 'blocks/Container/Container';
import Navigation from 'blocks/Navigation';
import SplashScreen from 'blocks/SplashScreen';
import InjectMetaTags from 'blocks/InjectMetaTags';
import NavigationAwarePageContent from 'blocks/NavigationAwarePageContent';
import Header1 from 'elements/Header1';
import Newsletter from 'kentico-blocks/Newsletter';
import PageNotFound from 'pages/PageNotFound';
import BlogArticleBox from './BlogArticleBox';
import LatestArticle from './LatestArticle';

const StyledContainer = styled(Container)`
  margin: ${ds.get('metrics.xl')} auto 0;

  ${media.desktop`
    margin: 200px auto ${ds.get('metrics.xl')};
  `};
`;

const StyledHeader = styled(Header1)`
  margin-bottom: 0;
  margin-left: ${ds.get('metrics.s')};
  font-size: ${ds.fs('xl')};

  ${media.tablet`
    font-size: ${ds.fs('xxl')};
  `};
`;

@inject('coreStore', 'blogStore', 'windowStore', 'appStore')
@observer
export default class Blog extends Component {
  articlesListRef = React.createRef();

  visibilitySensorSettings = {
    partialVisibility: 'bottom',
    offset: {
      bottom: 300,
    },
  };

  isInitialCategorySet = false;

  constructor(props) {
    super(props);
    this.state = {
      articleAuthor: null,
    };
  }

  async componentDidMount() {
    const { blogStore } = this.props;

    root.scrollTo(0, 0);

    await blogStore.initialContentFetch();

    const {
      history,
      location,
      match: {
        params: {
          category,
        },
      },
    } = this.props;

    const categoryCodename = category ? dashesToUnderscores(category) : '';

    if (location.state) {
      if (location.state.author && history.action === 'PUSH') {
        this.setState({ articleAuthor: location.state.author });
        blogStore.setBlogFilter(categoryCodename, true);
        return;
      }
    }

    const articleAuthor = blogStore.blogAuthors.find(author => author.value === categoryCodename);
    this.setState({ articleAuthor });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      blogStore,
      match: {
        params: {
          category,
        },
      },
    } = this.props;

    const categoryCodename = category ? dashesToUnderscores(category) : '';
    if (!this.isInitialCategorySet && blogStore.categoriesToRender.length > 1 && blogStore.blogAuthors.length > 1) {
      const articleAuthor = blogStore.blogAuthors.find(author => author.value === categoryCodename);

      this.setState({ articleAuthor });
      blogStore.setBlogFilter(categoryCodename, !!articleAuthor);
      this.isInitialCategorySet = true;
    }
  }

  @Bind()
  onCategoryChange(activeCategory) {
    const {
      blogStore,
      windowStore: {
        isOnTablet,
      },
      appStore: {
        currentLanguage,
      },
      history,
    } = this.props;

    const {
      articleAuthor,
    } = this.state;

    blogStore.setBlogFilter(activeCategory, !!articleAuthor);
    history.push(`${ANCHOR.BLOG[currentLanguage]}/${underscoresToDashes(activeCategory)}`);

    const offset = isOnTablet ? 0 : 150;
    if (this.articlesListRef && this.articlesListRef.current) {
      scrollTo(this.articlesListRef.current.node.offsetTop - offset);
    }
  }


  render() {
    const {
      blogStore,
      coreStore: {
        isLoaded,
        translations,
        content: {
          newsletter,
          blogSEO,
        },
        windowStore,
      },
    } = this.props;

    const {
      articleAuthor,
    } = this.state;

    const allArticlesLoaded = (
      blogStore.blogState.loadedArticlesCount >= blogStore.articlesDetails.length
    );

    const CoreStoreLoaded = isLoaded;

    if (!blogStore.isLoaded || !CoreStoreLoaded) {
      return <SplashScreen />;
    }

    if (!blogStore.loadArticles) {
      return <PageNotFound />;
    }
    return (
      <React.Fragment>
        <InjectMetaTags {...blogSEO} />
        <Navigation />
        <NavigationAwarePageContent>
          <StyledContainer>
            <Fade left distance={`${FADE_VALUES.BOX.LIGHT}`}>
              <StyledHeader>
                {articleAuthor ? articleAuthor.name : translations.BLOG_HEADER}
              </StyledHeader>
            </Fade>
          </StyledContainer>
          {blogStore.isLoaded && blogStore.latestArticle && !articleAuthor && (
            <LatestArticle
              backgroundImage={windowStore
                .adjustImageSize(blogStore.latestArticle.fullWidthListingImage)}
              article={blogStore.latestArticle}
              onSelect={this.onCategoryChange}
            />
          )}
          <Container>
            <VisibilitySensor
              {...this.visibilitySensorSettings}
              ref={this.articlesListRef}
              active={!allArticlesLoaded}
              onChange={isBottom => blogStore.setArticlesLimitInListingView(isBottom)}
            >
              <Row divisions={11}>
                {blogStore.loadArticles.map((article, index) => (
                  <Column
                    lg={3}
                    lgShift={index % 3 ? 1 : 0}
                    key={article.system.id}
                  >
                    <Fade>
                      <BlogArticleBox article={article} />
                    </Fade>
                  </Column>
                ))}
              </Row>
            </VisibilitySensor>

            {CoreStoreLoaded && (
              <Fade
                bottom
                distance={`${FADE_VALUES.BOX.LIGHT}`}
                delay={FADE_VALUES.DELAY.SMALL}
              >
                <Newsletter
                  margin={!windowStore.isOnTablet}
                  content={newsletter}
                />
              </Fade>
            )}
          </Container>
        </NavigationAwarePageContent>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Blog/index.jsx